module.exports = {"230125100":"宾州镇","230125101":"居仁镇","230125102":"宾西镇","230125103":"糖坊镇","230125104":"宾安镇","230125105":"新甸镇","230125106":"胜利镇","230125107":"宁远镇","230125109":"摆渡镇","230125110":"平坊镇","230125111":"满井镇","230125112":"常安镇","230125201":"永和乡","230125203":"鸟河乡","230125204":"民和乡","230125205":"经建乡","230125210":"三宝乡","230125500":"九龙山柞蚕育种场","230125579":"农垦农业职业学院"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230125.json
// module id = 772
// module chunks = 0